import {entityDelete, entitySave} from "./CallService";

export const teamSave = async(dbValues) => {
    return entitySave("team", dbValues);
}

export const teamDelete = async(teamId) => {
    return entityDelete("team", teamId);
}
